import type { ReviewOptions } from './types'

export interface ReviewFlowState {
  step: 'details' | 'review' | 'success'
  modelId: number | null
  levelId: number | null
  score: number
  message: string
  status: 'idle' | 'submitting' | 'error' | 'ownershipError'
  reviewId: number | null
}

export type ReviewFlowAction =
  | { type: 'model'; modelId: number | null; levelId: number | null }
  | { type: 'level'; levelId: number | null }
  | { type: 'score'; score: number }
  | { type: 'message'; message: string }
  | { type: 'step'; step: ReviewFlowState['step'] }
  | { type: 'status'; status: ReviewFlowState['status'] }
  | { type: 'submitted'; reviewId: number }

export const availableLevels = ({ levels, products }: ReviewOptions, modelId: number | null) =>
  modelId === null
    ? levels
    : levels.filter((level) => products.some((product) => product.modelId === modelId && product.levelId === level.id))

export const initialReviewState = (options: ReviewOptions, score: number, message = ''): ReviewFlowState => {
  const modelId = options.models.length === 1 ? options.models[0].id : null
  const levels = availableLevels(options, modelId)
  return {
    step: options.models.length > 1 || levels.length > 1 ? 'details' : 'review',
    modelId,
    levelId: levels.length === 1 ? levels[0].id : null,
    score,
    message,
    status: 'idle',
    reviewId: null,
  }
}

export const reviewFlowReducer = (state: ReviewFlowState, action: ReviewFlowAction): ReviewFlowState => {
  switch (action.type) {
    case 'model':
      return { ...state, modelId: action.modelId, levelId: action.levelId }
    case 'level':
      return { ...state, levelId: action.levelId }
    case 'score':
      return { ...state, score: action.score }
    case 'message':
      return { ...state, message: action.message }
    case 'step':
      return { ...state, step: action.step, status: 'idle' }
    case 'status':
      return { ...state, status: action.status }
    case 'submitted':
      return { ...state, step: 'success', status: 'idle', reviewId: action.reviewId }
  }
}
